import fetch from '@frontastic/bridge/js/fetch';

const GetCSRFToken = async (name) => {
  try {
    const response = await fetch(`/getCSRFToken/${name}`);
    const body = await response.json();

    return body.token;
  } catch (error) {
    console.error('Error from Fetch:', error);
  }
};

export default GetCSRFToken;
